<template>
  <div class="editor">
    <div v-if="isLoading || !translationLoaded.loaded" id="loading">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewbox="0 0 40 40"
        width="40"
        height="40"
      >
        <circle cx="20" cy="20" r="20" />
      </svg>
    </div>
    <Menu
      v-if="!isLoading && translationLoaded.loaded"
      :poster-state="posterState"
      :p5container="getP5Container"
      :is-mobile="isMobile"
      @audioAvailable="onAudioAvailable"
      @menuStepChanged="onMenuStepChanged"
    />
    <Poster
      v-if="!isLoading && translationLoaded.loaded"
      :poster-state="posterState"
      :sound-data="soundData"
      :menu-step="menuStep"
      :is-mobile="isMobile"
    />
  </div>
</template>

<script>
import Menu from './Menu'
import Poster from './Poster'
import * as SoundHelper from '../util/soundHelper.js'
import { translationLoaded } from '../util/i18n'

export default {
  name: 'Editor',
  props: {
    posterState: Object,
    soundData: Object,
    isLoading: Boolean,
  },
  components: {
    Menu,
    Poster,
  },
  data() {
    return {
      p5soundFile: null,
      menuStep: 1,
      isMobile: false,
      translationLoaded: translationLoaded,
    }
  },
  mounted() {
    if (
      typeof window.orientation !== 'undefined' ||
      navigator.userAgent.indexOf('IEMobile') !== -1
    ) {
      this.isMobile = true
    } else {
      this.isMobile = false
    }
  },
  computed: {
    getP5Container: function() {
      const sketch = function(p5) {
        p5.setup = function() {}
      }
      // eslint-disable-next-line no-undef
      return new p5(sketch, 'canvas-area')
    },
  },
  methods: {
    onAudioAvailable(p5soundFile) {
      this.p5soundFile = p5soundFile
      this.$emit('audioAvailable', {
        soundData: SoundHelper.getSoundData(this.p5soundFile),
      })
    },
    onMenuStepChanged(currenMenuStep) {
      this.menuStep = currenMenuStep
    },
  },
}
</script>

<style scoped lang="scss">
.editor {
  overflow: hidden;
  display: flex;
  background-color: white !important;
}

#loading {
  display: flex;
  justify-content: center;
  width: 100%;
  height: 100vh;
  align-items: center;
  svg {
    background-color: var(--colorPrimary);
    circle {
      fill: none;
      stroke: #f0ece6;
      stroke-width: 40px;
      shape-rendering: geometricPrecision;
      stroke-dasharray: 125;
      stroke-dashoffset: 250;
      transform-origin: 50%;
      transform: rotate(-90deg);
      animation: animate 2s linear infinite;
    }
    @keyframes animate {
      to {
        stroke-dashoffset: 0;
      }
    }
  }
}

@media only screen and (max-width: 480px) {
  .editor {
    overflow: visible;
    flex-direction: column-reverse;
    background-color: white !important;
  }
}

@media only print {
  .menuWrapper {
    display: none;
  }

  .poster,
  #posterMask {
    height: 100vh;
    width: 71.4285714vh;
  }

  .posterWrapper {
    padding: initial;
    display: initial;
  }

  .line {
    font-size: 1.15vh;
    margin-bottom: 1.564vh;
  }

  #tidio-chat {
    display: none;
  }
}
</style>
